import { render, staticRenderFns } from "./PsCard.vue?vue&type=template&id=437b7557&scoped=true&"
import script from "./PsCard.vue?vue&type=script&lang=js&"
export * from "./PsCard.vue?vue&type=script&lang=js&"
import style0 from "./PsCard.vue?vue&type=style&index=0&id=437b7557&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437b7557",
  null
  
)

component.options.__file = "PsCard.vue"
export default component.exports